import React from 'react';
import MultiStepSetup from '../../../libs/react-components-admin/instructions/multi-step-setup';
import Step1 from './step-1';
import Step2 from './step-2';
import Step3 from './step-3';

export default class InstructionsForShopifyCartPageOsV2 extends React.Component {

  render() {
    const steps = [
      { title: 'Step 1/3 - Displaying your form', component: <Step1 /> },
      { title: 'Step 2/3 - Customizing your form', component: <Step2 className="my-4"/> },
      { title: 'Step 3/3 - Testing your form', component: <Step3 /> },
    ];
    return <MultiStepSetup steps={steps}/>;
  }

}
